<template>
  <div id="homepage" class="home-page-container">
    <UserDashboard />
  </div>
</template>

<script>
import UserDashboard from '@/components/dashboard/UserDashboard.vue';

export default {
  name: 'Home',
  components: {
    UserDashboard,
  },
};
</script>
